module.exports = __webpack_public_path__ + "img/header-background-sell-record.8f1a5212.png";